import _stafetCommonStepsProps from 'foundation/js/configurations/_stafetCommonStepsProps'
import FormInputTextField from '../FormInputTextField/FormInputTextField.vue'
import FormInputTextarea from '../FormInputTextarea/FormInputTextarea.vue'
import FormInputDropdown from '../FormInputDropdown/FormInputDropdown.vue'
import FormCheckbox from '../FormCheckbox/FormCheckbox.vue'
import AdvancedRadio from '../AdvancedRadio/AdvancedRadio.vue'
import SupportSelector from '../SupportSelector/SupportSelector.vue'
import StafetActions from '../StafetActions/StafetActions.vue'
import StafetLysPoserList from '../StafetLysPoserList/StafetLysPoserList.vue'
import { computed, onBeforeMount, ref } from 'vue'
import getItemFromStorage from 'foundation/js/sessionStorageWrapper/getItemFromStorage'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import { useStore } from 'vuex'
import getFieldValue from 'foundation/js/stafet/getFieldValue'
import isBoolean from 'foundation/js/inputValidators/isBoolean'

export default {
    name: 'StafetDeltagPaaHoldStepTwo',
    components: {
        FormInputTextField,
        FormInputTextarea,
        FormInputDropdown,
        FormCheckbox,
        SupportSelector,
        StafetActions,
        StafetLysPoserList,
        AdvancedRadio
    },
    props: {
        lysposeQuantityOption1: {
            type: Number,
            required: true,
        },
        lysposeQuantityOption2: {
            type: Number,
            required: true,
        },
        lysposeQuantityOption3: {
            type: Number,
            required: true,
        },
        ..._stafetCommonStepsProps
    },
    setup(props) {
        const store = useStore()
        const isCustomAmount = ref(false)
        const donationAmount = ref(0)
        const donationPerLightBag = ref(props.lysposeMinimumAmount)
        const isLysposerDedicated = ref(false)
        const addPersonalNote = ref(false)
        const donationAmountList = ref([])
        const lightBagMeta = ref({})
        const supportSelector = ref({})

        const editorControlledDonationAmountList = ref([
            {
                label: `${props.lysposeQuantityOption1} ${props.labels.taendEtLysUnitLabel}`,
                value: props.lysposeQuantityOption1
            },
            {
                label: `${props.lysposeQuantityOption2} ${props.labels.taendEtLysUnitLabel}`,
                value: props.lysposeQuantityOption2
            },
            {
                label: `${props.lysposeQuantityOption3} ${props.labels.taendEtLysUnitLabel}`,
                value: props.lysposeQuantityOption3
            }
        ])

        onBeforeMount(() => {
            const storedFields = getItemFromStorage(
                sessionStorageIdentifierEnum.STAFET_JOIN_A_TEAM
            )

            if (storedFields) {
                if (getFieldValue(storedFields, 'donationAmount')) {
                    donationAmount.value = getFieldValue(
                        storedFields,
                        'donationAmount'
                    )
                    const lysposeQuantityOptions = [
                        props.lysposeQuantityOption1,
                        props.lysposeQuantityOption2,
                        props.lysposeQuantityOption3
                    ]
                    if (!lysposeQuantityOptions.includes(donationAmount.value)) {
                        isCustomAmount.value = true
                    }
                }

                if (getFieldValue(storedFields, 'donationPerLightBag')) {
                    donationPerLightBag.value = getFieldValue(
                        storedFields,
                        'donationPerLightBag'
                    )
                }

                if (getFieldValue(storedFields, 'isLysposerDedicated')) {
                    isLysposerDedicated.value = getFieldValue(
                        storedFields,
                        'isLysposerDedicated'
                    )
                }

                if (getFieldValue(storedFields, 'donationItems')) {
                    donationAmountList.value = getFieldValue(
                        storedFields,
                        'donationItems'
                    )
                }

                if (getFieldValue(storedFields, 'addPersonalNote')) {
                    addPersonalNote.value = getFieldValue(
                        storedFields,
                        'addPersonalNote'
                    )
                }

                if (getFieldValue(storedFields, 'donationFor')) {
                    store.dispatch('donation/donationFor', {
                        donationFor: getFieldValue(storedFields, 'donationFor')
                    })
                }

                if (getFieldValue(storedFields, 'donationTeam')) {
                    store.dispatch('donation/donationTeam', {
                        team: getFieldValue(
                            storedFields,
                            'donationTeam'
                        ).toString()
                    })
                }

                if (getFieldValue(storedFields, 'donationParticipant')) {
                    store.dispatch('donation/donationParticipant', {
                        participant: getFieldValue(
                            storedFields,
                            'donationParticipant'
                        )
                    })
                }
            }
        })

        const StafetFlowLightBagsMetaListLabels = {
            isLysposeDedicatedCheckboxLabel:
                props.labels.taendEtLysCustomizeLysposeBoolDedicatedLabel,
            personalNoteCheckboxLabel:
                props.labels.taendEtLysCustomizeLysposeBoolOwnNoteLabel,
            personalizeLightBagsTitle: props.labels.taendEtLysLysposeTitle,
            lightDedicatedToTextLabel:
                props.labels.taendEtLysLysposeDedicatedToLabel,
            lightDedicatedToErrorMessage:
                props.labels.taendEtLysLysposeDedicatedToErrorMessage,
            lightDedicatedToHelpTextLabel:
                props.labels.taendEtLysLysposeDedicatedToSubtext,
            personalNoteTextLabel:
                props.labels.taendEtLysLysposePersonalNoteLabel,
            personalNoteHelpTextLabel:
                props.labels.taendEtLysLysposePersonalNoteSubtext,
            personalNoteErrorMessage:
                props.labels.taendEtLysLysposePersonalNoteErrorMessage,
            dedicationTypeTextLabel:
                props.labels.taendEtLysLysposeDedicatedTypeLabel,
            dedicationTypePlaceholder:
                props.labels.taendEtLysLysposeDedicatedTypePlaceholder,
            dedicationTypeErrorMessage:
                props.labels.taendEtLysLysposeDedicatedTypeErrorMessage,
            inMemoryOf: props.labels.taendEtLysLysposeDedicatedTypeInMemoryOf,
            inSupportOf: props.labels.taendEtLysLysposeDedicatedTypeInSupportOf
        }

        const stepModel = computed(() => {
            const array = [
                {
                    name: 'donationAmount',
                    value: parseInt(donationAmount.value),
                    isValid: false,
                    validator: (value) => {
                        return value > 0
                    }
                },
                {
                    name: 'donationPerLightBag',
                    value: parseInt(donationPerLightBag.value),
                    isValid: false,
                    validator: (value) => {
                        return donationAmount.value > 0 ? value >= 50 : true
                    }
                },
                {
                    name: 'donationFor',
                    value: supportSelector.value.donationFor,
                    isValid: supportSelector.value.isValid,
                    validator: () => {
                        return supportSelector.value.isValid
                    }
                },
                {
                    name: 'donationTeam',
                    value: supportSelector.value.donationTeam,
                    isValid: supportSelector.value.isValid,
                    validator: () => {
                        return supportSelector.value.isValid
                    }
                },
                {
                    name: 'donationParticipant',
                    value: supportSelector.value.donationParticipant,
                    isValid: supportSelector.value.isValid,
                    validator: () => {
                        return supportSelector.value.isValid
                    }
                },
                {
                    name: 'donationItems',
                    value: lightBagMeta.value.donationItems,
                    isValid: lightBagMeta.value.isValid,
                    validator: () => {
                        return lightBagMeta.value.isValid
                    }
                },
                {
                    name: 'isLysposerDedicated',
                    value: lightBagMeta.value.isLysposerDedicated,
                    isValid: true,
                    validator: () => isBoolean
                },
                {
                    name: 'addPersonalNote',
                    value: lightBagMeta.value.addPersonalNote,
                    isValid: true,
                    validator: () => isBoolean
                }
            ]

            if (donationAmount.value > 0) {
                array.push({
                    name: 'donationItems',
                    value: lightBagMeta.value.donationItems,
                    isValid: lightBagMeta.value.isValid,
                    validator: () => {
                        return lightBagMeta.value.isValid
                    }
                })
            }

            return array
        })

        const chooseCustomAmount = () => {
            isCustomAmount.value = !isCustomAmount.value
        }

        const setDonationAmount = (e) => {
            const intValue = parseInt(e.target.value)
            donationAmount.value = intValue > 0 ? intValue : 0
        }

        const updateLightBagMeta = (data) => {
            lightBagMeta.value = data
        }

        const updateSupportSelector = (data) => {
            supportSelector.value = data
        }

        const setDonationPerLightBag = (value) => {
            donationPerLightBag.value = value
        }

        const showDonationAmoutErrorMessage = computed(() => {
            return props.displayInputError && donationAmount.value === 0
        })

        const showDonationPerLightBagErrorMessage = computed(() => {
            return (
                props.displayInputError &&
                donationPerLightBag.value < props.lysposeMinimumAmount
            )
        })

        return {
            isCustomAmount,
            editorControlledDonationAmountList,
            donationAmountList,
            donationAmount,
            donationPerLightBag,
            isLysposerDedicated,
            addPersonalNote,
            StafetFlowLightBagsMetaListLabels,
            stepModel,
            chooseCustomAmount,
            setDonationAmount,
            updateLightBagMeta,
            updateSupportSelector,
            setDonationPerLightBag,
            showDonationAmoutErrorMessage,
            showDonationPerLightBagErrorMessage
        }
    }
}
